import React, {useContext} from 'react';
import MobXContext from "../../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import MenuInput from "../MenuInput/MenuInput";
import {SelectInput, Size} from "@dts-soldel/dts-react-common";
import HelpIcon from "../../HelpIcon/HelpIcon";
import HelpText from "../../HelpIcon/HelpText";
import POPUP_MENU_STYLE from "../../../../../../../src/js/misc/popupMenuStyle";

const propTypes = {
	iconName: PropTypes.string.isRequired,
};
const defaultProps = {};

const IconInputMenu = ({iconName}) => {
	const {configuratorStore} = useContext(MobXContext);
	const menu = configuratorStore[`${iconName}IconMenu`];

	const onMenuStyleChange = (field, value) => {
		configuratorStore[`${iconName}IconMenuStyle`] = value;
		configuratorStore.fieldWasUpdated(`${iconName}IconMenuStyle`);
	};

	return (
		<>
			<div className="menu-input__container">
				<SelectInput
					size={Size.FULL_WIDTH}
					field="menuStyle"
					label="Menu Style"
					options={[
						{label: 'Default', value: POPUP_MENU_STYLE.DEFAULT},
						{label: 'Card', value: POPUP_MENU_STYLE.CARD},
						{label: 'Grid', value: POPUP_MENU_STYLE.GRID},
					]}
					onChange={onMenuStyleChange}
					value={configuratorStore[`${iconName}IconMenuStyle`]}
					children={
						<HelpIcon
							popOverText={HelpText.menuStyle}
							onUseExampleField="menuStyle"
							onUseExampleFieldValue={onMenuStyleChange}
						/>
					}
				/>
			</div>

			<MenuInput allowSubMenuItems={false} menu={menu}/>
		</>
	);
};

IconInputMenu.propTypes = propTypes;
IconInputMenu.defaultProps = defaultProps;

export default observer(IconInputMenu);
